/**
 * 获取指定接口的信息
 * @param {Number} index_  接口索引
 * @returns {Object} intItem   会议列表: { url: '', istoken: true, desc: '' }
 */
function getInterfaceInfo(index_) {
  //   return $interfaceName[Object.keys($interfaceName)[index_]]
  return Object.keys($interfaceName)[index_]
}

function getInterfaceIndex(interfaceIndexData) {
  if(interfaceIndexData){
    const tempData = interfaceIndexData.split(' ')
    if (tempData.length > 1) {
      return tempData[1]
    } else {
      return -1
    }
  }else{
    return -1
  }
  
}

function setPagination(store, DBData, interfaceIndex) {
   
  const index_ = getInterfaceIndex(interfaceIndex)
  const itemName = getInterfaceInfo(index_)
  if (!DBData || !DBData.pageNum) {
    return
  }
  const {
    pageNum,
    pageSize,
    pages,
    total
  } = DBData
}

function getPagination(store, interfaceIndex) {
  
  const index_ = getInterfaceIndex(interfaceIndex)
  const itemName = getInterfaceInfo(index_)
  let itemPaginationData = store.getters.getPagination[itemName]
  //   isRequest: false pageNum: 1 pageSize: 10 pages: 1
  if (itemPaginationData) {
    itemPaginationData.pageSize = 100
    itemPaginationData.pages = 1
    if (itemPaginationData.pageNum < itemPaginationData.pages && itemPaginationData.isRequest) {
      itemPaginationData.pageNum = itemPaginationData.pageNum + 1
    } else {
      itemPaginationData.pageNum = itemPaginationData.pages
    }
  }

  return itemPaginationData
}

export default (funName, store, DBData, interfaceIndex) => {
  if (funName === 'setPagination') {
    setPagination(store, DBData, interfaceIndex)
  }
  if (funName === 'getPagination') {
    return getPagination(store, interfaceIndex)
  }
}
